export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8171.b25e24fc.jpg";